import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller.ts"
import { InstructionFeedbackActivityTemplateProduct } from "@/models/instruction-feedback-activity-template-product.model.ts"
import type { IInstructionFeedbackActivityTemplateProduct } from "@/interfaces/api/instruction-feedback-activity-template-product.interface.ts"
import { InstructionFeedbackActivityTemplateProductRepository } from "@/repositories/instruction-feedback-activity-template-product-repository.ts"
import type { IStoreFunctionsConfig } from "@/store/base-functions/base-store-functions.ts"

export class InstructionFeedbackActivityTemplateProductController extends GenericModelController<
  InstructionFeedbackActivityTemplateProduct,
  IInstructionFeedbackActivityTemplateProduct,
  InstructionFeedbackActivityTemplateProductRepository
> {
  constructor(
    storeFunctionsConfig?: IStoreFunctionsConfig<InstructionFeedbackActivityTemplateProduct>
  ) {
    if (!storeFunctionsConfig) {
      storeFunctionsConfig = { managed: false }
    }

    super(
      InstructionFeedbackActivityTemplateProduct,
      storeFunctionsConfig,
      new InstructionFeedbackActivityTemplateProductRepository()
    )
  }
}
